<div class="page-container">


  <div class="page-content">
    <div class="container">
      <div class="contact-header">
        <h1>{{ 'CONTACT.TITLE' | translate }}</h1>
        <p class="subtitle">{{ 'CONTACT.SUBTITLE' | translate }}</p>
      </div>

      <div class="contact-grid">
        <div class="contact-info">
          <div class="info-card">
            <div class="info-icon">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <h3>{{ 'CONTACT.ADDRESS_TITLE' | translate }}</h3>
            <p>{{ 'CONTACT.ADDRESS_LINE_1' | translate }}<br>{{ 'CONTACT.ADDRESS_LINE_2' | translate }}<br>{{ 'CONTACT.ADDRESS_LINE_3' | translate }}</p>
          </div>

          <div class="info-card">
            <div class="info-icon">
              <i class="fas fa-phone"></i>
            </div>
            <h3>{{ 'CONTACT.PHONE_TITLE' | translate }}</h3>
            <p>{{ 'CONTACT.PHONE_NUMBER' | translate }}</p>
            <p>{{ 'CONTACT.PHONE_HOURS' | translate }}</p>
          </div>

          <div class="info-card">
            <div class="info-icon">
              <i class="fas fa-envelope"></i>
            </div>
            <h3>{{ 'CONTACT.EMAIL_TITLE' | translate }}</h3>
            <p>{{ 'CONTACT.EMAIL_PRIMARY' | translate }}</p>
            <p>{{ 'CONTACT.EMAIL_SUPPORT' | translate }}</p>
          </div>
        </div>

        <div class="contact-form">
          <h2>{{ 'CONTACT.MESSAGE_TITLE' | translate }}</h2>
          <form>
            <div class="form-group">
              <input type="text" [placeholder]="'CONTACT.NAME_PLACEHOLDER' | translate" class="form-control">
            </div>

            <div class="form-group">
              <input type="email" [placeholder]="'CONTACT.EMAIL_PLACEHOLDER' | translate" class="form-control">
            </div>

            <div class="form-group">
              <input type="text" [placeholder]="'CONTACT.SUBJECT_PLACEHOLDER' | translate" class="form-control">
            </div>

            <div class="form-group">
              <textarea [placeholder]="'CONTACT.MESSAGE_PLACEHOLDER' | translate" rows="6" class="form-control"></textarea>
            </div>

            <button type="submit" class="submit-btn">{{ 'CONTACT.SEND_BUTTON' | translate }}</button>
          </form>
        </div>
      </div>

      <div class="map-section">
        <h2>{{ 'CONTACT.FIND_US_TITLE' | translate }}</h2>
        <div class="map-placeholder">
          <div class="map-content">
            <i class="fas fa-map"></i>
            <p>{{ 'CONTACT.MAP_PLACEHOLDER' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
